
import { AppBar, Box, Toolbar, TextField, Modal, useTheme, Table, TableCell, TableBody, Checkbox, TableContainer, TableHead, TableRow, IconButton, Button, Menu, MenuItem, ListItemIcon, ListItemText, Divider, CssBaseline, alpha, } from "@mui/material";
import React, { useState, useEffect } from "react";



import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Close from '@mui/icons-material/Close';
import HelpIcon from '@mui/icons-material/HelpOutline';
import AddNewVendor from "./AddNewVendor";

import { tokens } from "../../../theme/theme";

import Searchicon from '@mui/icons-material/Search';
import CustomTableContainer from "../../../Layout/CustomTableContainer";
import { callApi } from "../../../utils/apiClient";
import { API_ENDPOINTS } from "../../../config/api/apiCall";
import { useTableRecordsPerPage } from "../../../Layout/useTableRecordsPerPage";
import TableFilterRow from "../../../components/table/TableFilterRow";
import ResponsiveBox from "../../../Layout/ResponsiveScrollBox";
import CustomPagination from "../../../components/table/CustomPagination";
import SkeletonTableLoader from "../../../components/table/SkeletonTableLoader";

const Vendor = ({ handleBackWinderMachineEntry }) => {

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // State for first menu
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('All Supplier');
    const openFirst = Boolean(anchorElFirst);
    const [newVendor, setNewVendor] = useState(false);
    const [vendorHome, setVendorHome] = useState(true);

    const [loading, setloading] = useState(true);

    // State for second menu
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    // const [selectedOptionSecond, setSelectedOptionSecond] = useState('');
    const openSecond = Boolean(anchorElSecond);

    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };

    const handleMenuItemClickFirst = (option) => {
        setSelectedOptionFirst(option); // Update the selected option
        handleMenuCloseFirst();

        if (option === 'All Supplier') {
            setSelectedStatus('All');
        }
        else if (option === 'Active Supplier') {
            setSelectedStatus('Active');
        }
        else if (option === 'Inactive Supplier') {
            setSelectedStatus('InActive');
        }


        setAnchorElFirst(null);
    };

    // Handlers for second menu
    const handleMenuClickSecond = (event) => {
        setAnchorElSecond(event.currentTarget);
    };

    const handleMenuCloseSecond = () => {
        setAnchorElSecond(null);
    };

    const handleMenuItemClickSecond = (option) => {
        // setSelectedOptionSecond(option); // Update the selected option
        handleMenuCloseSecond();
    };

    const handleShowNewVendor = () => {
        setEditPartyID(0);
        setVendorHome(false);
        setNewVendor(true);
    }

    const handlecallback = () => {
        setEditPartyID(0);
        setVendorHome(true);
        setNewVendor(false);
        const para = {
            p_companyid: 13,
        }
        setloading(true);

        callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
            .then(data => {
                if (data && data.length > 0) {
                    setPartyList(data);
                    setloading(false);
                }
                else
                { setloading(false); }
            })
            .catch(error => {
                setloading(false);
                alert(error.message);

            });
    }

    const [isDataLoaded, setIsDataLoaded] = useState(false);
    const [employeeDetails, setemployeeDetails] = useState([]);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 1,
            }

            callApi(API_ENDPOINTS.Example_Employee_form, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setemployeeDetails(data);
                    }
                })
                .catch(error => {
                    alert(error.message);
                });

        }
    }, [isDataLoaded]);


    const [partyList, setPartyList] = useState([]);

    useEffect(() => {
        if (!isDataLoaded) {

            const para = {
                p_companyid: 13,
            }
            setloading(true);
            callApi(API_ENDPOINTS.GETPartyList, 'POST', { 'Content-Type': 'application/json' }, para)
                .then(data => {
                    if (data && data.length > 0) {
                        setPartyList(data);
                        setloading(false);
                    }
                    else
                    {
                        setloading(false);
                    }
                })
                .catch(error => {
                    setloading(false);
                    alert(error.message);

                });

        }
    }, [isDataLoaded]);


    const [filters, setFilters] = useState({
        name: '',
        companyname: '',
        email: '',
        workphone: '',
        status: '',
        payales: '',


        unit: '',
        party_type: '',
        gst_number: '',
        parent_party: '',
        tcsapplicable: '',
        fysalevalue: '',

    });



    const [selectedStatus, setSelectedStatus] = useState('All');

    const filteredData = partyList.filter((row) => {
        // Check if row matches selected status
        if (selectedStatus === 'All' || row.status === selectedStatus) {
            // Check if all filter fields match
            return Object.keys(filters).every((key) => {
                if (filters[key] === '') return true; // No filter applied
                return String(row[key]).toLowerCase().includes(filters[key].toLowerCase());
            });
        }
        return false;
    });

    const [editPartyID, setEditPartyID] = useState(0)
    const handleCallEdit = (value) => {
        setEditPartyID(value);
        setVendorHome(false);
        setNewVendor(true);
    };


    const safeFilteredData = filteredData || [];
    const safeTableData = partyList || [];
    const [currentPage, setCurrentPage] = useState(1);

    const recordsPerPage = useTableRecordsPerPage(200, 30);

    const pageCount = Math.ceil(safeFilteredData.length / recordsPerPage);

    const handleFilterChange = (e, column) => {
        setFilters({ ...filters, [column]: e.target.value });
    };

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
    };

    const uniqueValues = {
        name: [...new Set(safeTableData.map(row => row.name))],
        companyname: [...new Set(safeTableData.map(row => row.companyname))],

        party_type: [...new Set(safeTableData.map(row => row.party_type))],
        

        status: [...new Set(safeTableData.map(row => row.status))],
    };

    // Get the records for the current page
    const currentRecords = safeFilteredData.slice(
        (currentPage - 1) * recordsPerPage,
        currentPage * recordsPerPage
    );


    const filterColumns = ['name', 'companyname', 'unit', 'party_type', 'gst_number', 'parent_party', 'tcsapplicable', 'fysalevalue', 'email', 'workphone', 'status', 'payales',];

    const autoCompleteColumns = ['name', 'companyname', 'party_type', 'status'];



    return (
        <Box >
            <CssBaseline />
            {vendorHome && (

                <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                    <Toolbar>
                        {/* First Menu */}
                        <Button
                            color="secondary"
                            onClick={handleMenuClickFirst}
                            endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                            sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                        >
                            {selectedOptionFirst}
                        </Button>
                        <Menu
                            anchorEl={anchorElFirst}
                            open={openFirst}
                            onClose={handleMenuCloseFirst}

                        >
                            <MenuItem onClick={() => handleMenuItemClickFirst('All Supplier')}>All Supplier</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Active Supplier')}>Active Supplier</MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickFirst('Inactive Supplier')}>Inactive Supplier</MenuItem>
                        </Menu>

                        {/* Adding margin-left: auto to push the button to the right */}
                        <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                        {/* Second Menu */}
                        <IconButton
                            size="small"
                            // edge="start"
                            // color="inherit"
                            aria-label="menu"
                            sx={{ ml: 2 }}
                            onClick={handleMenuClickSecond}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        <Menu
                            anchorEl={anchorElSecond}
                            open={openSecond}
                            onClose={handleMenuCloseSecond}
                        >
                            <MenuItem onClick={() => handleMenuItemClickSecond('Import Supplier')}>
                                <ListItemIcon>
                                    <ImportExportIcon />
                                </ListItemIcon>
                                <ListItemText primary="Import Supplier" />
                            </MenuItem>
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Supplier')}>
                                <ListItemIcon>
                                    <FileDownloadIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Supplier" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                                <ListItemIcon>
                                    <ViewColumnIcon />
                                </ListItemIcon>
                                <ListItemText primary="Export Current View" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                                <ListItemIcon>
                                    <ListAltIcon />
                                </ListItemIcon>
                                <ListItemText primary="Preference " />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                                <ListItemIcon>
                                    <RefreshIcon />
                                </ListItemIcon>
                                <ListItemText primary="Refresh List" />
                            </MenuItem>
                            <Divider />
                            <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                                <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                    Reset Columns Width
                                </Button>
                            </MenuItem>
                        </Menu>

                        <IconButton
                            size="small"

                            aria-label="menu"
                            sx={{ mr: 1, ml: 1 }}
                            onClick={handleMenuClickSecond}
                        >
                            <HelpIcon sx={{ fontSize: "18px" }} />
                        </IconButton>

                        <div>
                            <IconButton onClick={handleBackWinderMachineEntry} >
                                <Close fontSize="inherit" sx={{ fontSize: "18px", color: "#2196F3" }} />
                            </IconButton>
                        </div>
                    </Toolbar>
                </AppBar>
            )}

            {vendorHome && (
                <>
                    <ResponsiveBox colors={colors} customMaxHeight={{ xs: '72vh', sm: '72vh', md: '74vh', lg: '74vh', xl: '82vh' }}>

                        <CustomTableContainer colors={colors}>
                            <TableContainer >
                                {loading ? (
                                    <SkeletonTableLoader rows={5} columns={11} />
                                ) : (
                                    <Table size="small">
                                        <TableHead sx={{ height: 10 }}>
                                            <TableRow>
                                                {/* <TableCell>
                                        <Checkbox size="small" style={{ color: "secondary" }}
                                            indeterminate={selectedRows.length > 0 && selectedRows.length < filteredData.length}
                                            checked={selectedRows.length === filteredData.length}
                                            onChange={handleSelectAllClick}
                                        />
                                    </TableCell> */}
                                                <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>NAME</TableCell>
                                                <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>COMPANY NAME</TableCell>
                                                <TableCell>UNIT</TableCell>
                                                <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>SUPPLIER TYPE</TableCell>
                                                <TableCell>GST NO</TableCell>
                                                <TableCell >PARENT COMPANY</TableCell>
                                                <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>TCS APPLICABLE</TableCell>
                                                <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>FY SALE VALUE</TableCell>
                                                <TableCell>EMAIL</TableCell>
                                                <TableCell sx={{ textAlign: "center", minWidth: 120, whiteSpace: "nowrap" }}>WORK PHONE</TableCell>
                                                <TableCell>STATUS</TableCell>
                                                <TableCell>PAYABLES</TableCell>

                                            </TableRow>
                                            <TableFilterRow
                                                columns={filterColumns}
                                                filters={filters}
                                                handleFilterChange={handleFilterChange}
                                                uniqueValues={uniqueValues}
                                                autoCompleteColumns={autoCompleteColumns}
                                            />
                                        </TableHead>
                                        <TableBody>
                                            {(currentRecords || []).map((row, index) => (


                                                <TableRow key={row.id} sx={{
                                                    backgroundColor:
                                                        index % 2 === 0
                                                            ? theme.palette.background.default
                                                            : alpha(theme.palette.action.hover, 0.02), // slightly darker
                                                }}>
                                                    {/* <TableCell>
                                            <Checkbox
                                                size="small"
                                                checked={isSelected(row.id)}
                                                onChange={(event) => handleRowCheckboxClick(event, row.id)}
                                            />
                                        </TableCell> */}

                                                    <TableCell >
                                                        <span
                                                            style={{ color: 'teal', textDecoration: 'underline', cursor: 'pointer' }}
                                                            onClick={() => handleCallEdit(row.id)}
                                                        >
                                                            {row.name}
                                                        </span>
                                                    </TableCell>
                                                    <TableCell >{row.companyname}</TableCell>
                                                    <TableCell>{row.unit}</TableCell>
                                                    <TableCell>{row.party_type}</TableCell>
                                                    <TableCell>{row.gst_number}</TableCell>
                                                    <TableCell >{row.parent_party}</TableCell>
                                                    <TableCell>{String(row.tcsapplicable)}</TableCell>
                                                    <TableCell sx={{ textAlign: "right" }}>{row.fysalevalue}</TableCell>
                                                    <TableCell>{row.email}</TableCell>
                                                    <TableCell sx={{ textAlign: "right" }}>{row.workphone}</TableCell>
                                                    <TableCell>{row.status}</TableCell>
                                                    <TableCell>{row.payales}</TableCell>

                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                )}
                            </TableContainer>
                        </CustomTableContainer>
                    </ResponsiveBox>

                    <CustomPagination pageCount={pageCount} currentPage={currentPage} onPageChange={handlePageChange} />
                </>
            )}


            {newVendor && (
                <>
                    <AddNewVendor handlecallback={handlecallback} editPartyID={editPartyID} />
                </>
            )}
        </Box>
    );
}

export default Vendor;




